<template>
  <div>
    <v-container fluid>
      <material-card icon="mdi-clipboard-text" inline title="Create Fee Type">
        <v-card-actions>
          <a @click="$router.back()">
            <v-btn elevation="1" absolute right top> <v-icon left>mdi-arrow-left</v-icon>back</v-btn>
          </a>
        </v-card-actions>
        <v-card flat class="px-2">
          <form autocomplete="off" @submit.prevent="saveType">
            <v-row>
              <v-col cols="12" md="6">
                <label class="font-weight-medium body-2">
                  Fee Type Name
                  <span class="requir error--text">*</span>
                </label>
                <v-text-field class="my-0 py-1" required placeholder="Fee Type name" pattern="[a-zA-Z\s]+"
                  title="Enter valid character" v-model.trim="feeObj.feeName" maxlength="100"></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <label class="font-weight-medium body-2">
                  Invoice Fee Name
                  <span class="requir error--text">*</span>
                </label>
                <v-text-field class="my-0 py-1" required placeholder="Invoice Fee Name" pattern="[a-zA-Z\s]+"
                  title="Enter valid character" v-model.trim="feeObj.InvoiceFeeName" maxlength="100"></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <label class="font-weight-medium body-2">
                  Is Royalty Applicable
                  <span class="requir error--text">*</span>
                </label>
                <v-autocomplete class="my-0 py-1" :items="items" item-value="value" item-text="text"
                  placeholder="--is Royalty--" v-model="feeObj.royalty" required> </v-autocomplete>
              </v-col>
              <v-col cols="12" md="6">
                <label class="font-weight-medium body-2">
                  Priority
                  <span class="requir error--text">*</span>
                </label>
                <v-text-field type="number" v-model="feeObj.priority"
                  oninput="if(this.value < 0) this.value = 0;"></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-card-actions class="d-flex justify-end">
                  <v-btn bottom right elevation="1" color="primary" type="submit">
                    <v-icon left> mdi-content-save </v-icon>
                    Save</v-btn>
                </v-card-actions>
              </v-col>
            </v-row>
          </form>
        </v-card>
      </material-card>
    </v-container>
  </div>
</template>
<script>
import MaterialCard from '@/components/template/MaterialCard'
import constants from '@/utils/constants'
export default {
  components: { MaterialCard },
  data () {
    return {
      items: [
        { text: 'Yes', value: true },
        { text: 'No', value: false }
      ],
      feeObj: {
        feeName: '',
        InvoiceFeeName: '',
        royalty: '',
        priority: 0
      },
      isLoading: false
    }
  },
  methods: {
    saveType: async function () {
      if (!this.feeObj.priority) {
        this.errMsg('Kindly add Priority!!')
        return false
      }
      try {
        this.isLoading = true
        let formData = new FormData()
        formData.append('name', this.feeObj.feeName)
        formData.append('InvoiceFeeName', this.feeObj.InvoiceFeeName)
        formData.append('priority', this.feeObj.priority)
        formData.append('isRoyalty', this.feeObj.royalty)
        const res = await http.post(`${constants.API_URL}/api/add-fee-type`, formData)
        if (res) {
          this.$router.push({ name: 'AddViewFeeTypes' })
          this.okMsg('User information added successfully!')
          this.resetAll()
        }

        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    resetAll () {
      this.feeObj.InvoiceFeeName = ''
      this.feeObj.feeName = ''
      this.feeObj.priority = 0
      this.feeObj.royalty = ''
    },
    okMsg (msg) {
      return this.$dialog.info({
        title: 'Success',
        text: msg
      })
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    }
  }
}
</script>
